import enums from "../../enums/enums";
import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";
import helper from "../transaction/transactionHelper";
export default {
  DoGetSettingTransactionDueDate(isUseMainDatabase) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      isUseMainDatabase: isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/Merchant/GetSettingTransactionDueDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTransactionRemark(isUseMainDatabase) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      isUseMainDatabase: isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/Merchant/GetSettingTransactionRemark", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantListByUserId(isUseMainDatabase = false) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { isUseMainDatabase: isUseMainDatabase };
    return API.peakRealTimeAPIForUser.get("/api/Merchant/GetMerchantListByUserId", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetSelectedMerchant(merchantId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { merchantId: merchantId };

    return API.peakRealTimeAPIForUser.get("/api/Merchant/GetSelectedMerchant", { params, headers }).then((res) => {
      return res;
    });
  },
  DoInsertMerchant(input) {
    let _input = {
      merchantId: 0,
      userName: input.userEmail,
      createMerchantModel: input.createMerchantModel,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/InsertMerchant", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoGetSettingTransactionNumber(isUseMainDatabase) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      isUseMainDatabase: isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/Merchant/GetSettingTransactionNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantDetail() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetMerchantDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantAddressList() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetMerchantAddressList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertSampleMerchant(input) {
    let _input = {
      merchantId: 0,
      createMerchantModel: null,
      isSample: true,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/InsertMerchant", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateMerchantDetail(merchant) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      merchant: merchant,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateMerchant", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateMerchantLogoAndStamp(updateMerchantLogoAndStamp) {
    const formData = new FormData();
    const updateMerchantLogoAndStampData = {
      ...updateMerchantLogoAndStamp,
    };
    delete updateMerchantLogoAndStampData.logo;
    delete updateMerchantLogoAndStampData.Stamp;
    formData.append("merchantId", userInfo.MerchantId());
    if (updateMerchantLogoAndStamp.logo.rawString.startsWith("data:")) {
      const blobLogo = helper.Base64ToBlob(
        updateMerchantLogoAndStamp.logo.rawString,
        updateMerchantLogoAndStamp.logo.fileType
      );
      formData.append(`logo`, blobLogo, updateMerchantLogoAndStamp.logo.fileName);
    }
    if (updateMerchantLogoAndStamp.Stamp.rawString.startsWith("data:")) {
      const blobStamp = helper.Base64ToBlob(
        updateMerchantLogoAndStamp.Stamp.rawString,
        updateMerchantLogoAndStamp.Stamp.fileType
      );
      formData.append(`stamp`, blobStamp, updateMerchantLogoAndStamp.Stamp.fileName);
    }
    formData.append("updateMerchantLogoAndStamp", JSON.stringify(updateMerchantLogoAndStampData));
    return API.peakRealTimeAPIForImport
      .post("/api/Merchant/UpdateMerchantLogoAndStamp", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetContactSetting(input) {
    return API.peakRealTimeAPI.post("/api/Merchant/GetContactSetting", userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateContactSetting(input) {
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateContactSetting", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateMerchantSettingCreateDuplicateName(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      isAllowDuplicateContact: input.isAllowDuplicateContact,
      isAllowDuplicateProduct: input.isAllowDuplicateProduct,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateMerchantSettingCreateDuplicateName", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateMerchantSettingTransactionNumber(merchantSettingTransactionNumber) {
    const _input = {
      merchantSettingTransactionNumber: merchantSettingTransactionNumber,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateMerchantSettingTransactionNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateMerchantSettingTransactionRemark(settingTransactionRemarkList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      settingTransactionRemarkList: settingTransactionRemarkList,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateMerchantSettingTransactionRemark", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateMerchantSettingTransactionDueDate(settingTransactionDueDateList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      settingTransactionDueDateList: settingTransactionDueDateList,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateMerchantSettingTransactionDueDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantSettingEmailReport() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetMerchantSettingEmailReport", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateMerchantEmailReport(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      emailReport: {
        revenueExpenseMonthlyReport: input.revenueExpenseMonthlyReport,
        revenueExpenseWeeklyReport: input.revenueExpenseWeeklyReport,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateMerchantEmailReport", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoGetMerchantSettingScbQrConfig() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetMerchantSettingScbQrConfig", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateMerchantSettingScbQrConfig(scbQrConfig) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      scbQrConfig: scbQrConfig,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateMerchantSettingScbQrConfig", _input, userInfo.SetHeaderService())

      .then((res) => {
        return res;
      });
  },
  DoRemoveMerchantSettingScbQrConfig() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/RemoveMerchantSettingScbQrConfig", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVerificationMerchant(verificationMerchantModel) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      verificationMerchantModel: verificationMerchantModel,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/VerificationOrganizationMerchant", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVerificationMerchantByMatchLink(verificationMerchantModel) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: verificationMerchantModel,
    };
    return API.peakAppConnect
      .post("/api/MatchLink/VerificationMerchant", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRefreshVerifiedStatus() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/RefreshVerifiedStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoAddPeakSupport(settingTransactionRemarkList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/User/AddPeakSupport", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetUserRoleDetailByUserId(userId) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { userId: userId };
    return API.peakRealTimeAPI.get("/api/User/GetUserRoleDetailByUserId", { params, headers }).then((res) => {
      return res;
    });
  },
  DoUpdateUserRole(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      userId: input.userId,
      userRole: input.userRole,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/User/UpdateUserRole", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetOnlineviewPaymentChannelSetting() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetOnlineviewPaymentChannelSetting", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateOnlineviewPaymentChannelSetting(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      settingOnlineviewPaymentChannelModel: input.settingOnlineviewPaymentChannelModel,
      isQrPayment: input.isQrPayment,
      qrPaymentCodeModel: input.qrPaymentCodeModel,
      qrPaymentTypeId: input.qrPaymentTypeId,
      isUpdateImage: input.isUpdateImage,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateOnlineviewPaymentChannelSetting", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateMerchantDefaultTaxStatus(taxStatus) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      taxStatus: taxStatus,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateMerchantDefaultTaxStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateMerchantLockPeriod(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      isLockPeriod: input.isLockPeriod,
      lockPeriodEndDate: input.lockPeriodEndDate,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateMerchantLockPeriod", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoGetGoogleGmailUser() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/EDocument/GetGoogleGmailUser", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoSetGoogleGmailConnect(authenticationCode) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: authenticationCode,
    };
    return API.peakAppConnect
      .post("/api/EDocument/SetGoogleGmailConnect", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteGoogleGmail() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/EDocument/DeleteGoogleGmail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetETaxConnectSetting() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/ETaxConnect/GetETaxConnectSetting", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateETaxConnectSetting(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      invoiceOnlineViewType: input.invoiceOnlineViewType,
      receiptOnlineViewType: input.receiptOnlineViewType,
      taxInvoiceOnlineViewType: input.taxInvoiceOnlineViewType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/ETaxConnect/UpdateETaxConnectSetting", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetINetAuthenticationData() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/EDocument/GetINetAuthenticationData", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateINetAuthenticationData(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        sellerTaxId: input.sellerTaxId.value,
        sellerBranchId: input.sellerBranchId.value,
        apiKey: input.apiKey.value,
        userCode: input.userCode.value,
        accessKey: input.accessKey.value,
        accessToken: input.accessToken.value,
      },
    };
    return API.peakAppConnect
      .post("/api/EDocument/UpdateINetAuthenticationData", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteINetAuthenticationData() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/EDocument/DeleteINetAuthenticationData", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetETaxInvoiceData(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      financeType: input.financeType,
      eTaxDataStatus: input.eTaxDataStatus,
      eDocumentType: input.eDocumentType,
    };
    return API.peakReportAPI
      .post("/api/ETaxInvoice/GetETaxInvoiceData ", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetETaxInvoiceInfo(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      eTaxInvoiceId: input.eTaxInvoiceId,
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      financeType: input.financeType,
    };
    return API.peakRealTimeAPI
      .post("/api/ETaxConnect/GetETaxInvoiceInfo ", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  SendETaxInvoiceByINet(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        generateKey: input.generateKey,
        transactionId: input.transactionId,
        transactionType: input.transactionType,
        financeType: input.financeType,
        eDocumentType: input.eDocumentType,
      },
    };
    return API.peakAppConnect
      .post("/api/EDocument/SendETaxInvoiceByINet", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetETaxInvoiceByINet(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        transactionId: input.transactionId,
        transactionType: input.transactionType,
        financeType: input.financeType,
        eDocumentType: input.eDocumentType,
      },
    };
    return API.peakAppConnect
      .post("/api/EDocument/GetETaxInvoiceByINet", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  SendETaxInvoiceByGoogleGmail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        generateKey: input.generateKey,
        transactionId: input.transactionId,
        transactionType: input.transactionType,
        financeType: input.financeType,
        eDocumentType: input.eDocumentType,
        emailMessage: {
          toEmail: input.toEmail,
          toCcEmail: input.ccEmail,
          toBccEmail: input.bccEmail,
          linkFile: input.linkFile,
          messageFromSender: input.messageFromSender,
          sendEmail: input.sendEmail.email,
          selectLanguageTemplateId: input.selectTemplateId,
          contactPerson: input.contactPerson,
          isShowInformationSender: input.isShowInformationSender,
          isShowImageSender: input.isShowImageSender,
        },
      },
    };
    return API.peakAppConnect
      .post("/api/EDocument/SendETaxInvoiceByGoogleGmail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  VoidETaxInvoiceByINet(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      financeType: input.financeType,
      eDocumentType: input.eDocumentType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/ETaxConnect/VoidETaxInvoiceByINet", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  VoidETaxInvoiceByGoogleGmail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      financeType: input.financeType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/ETaxConnect/VoidETaxInvoiceByGoogleGmail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantSettingApiPartnerUserToken() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetApiPartnerUserToken", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertApiPartnerRequest(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      userId: input.userId,
      applicationName: input.applicationName,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/AddApiPartnerRequest", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertMerchantSettingApiPartnerUserToken(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      userId: input.userId,
      apiPartnerType: input.apiPartnerType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/InsertApiPartnerUserToken", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRemoveMerchantSettingApiPartnerUserToken(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      userTokenId: input.userTokenId,
      apiPartnerType: input.apiPartnerType,
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/RemoveApiPartnerUserToken", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateOnlineViewPublicFormatSetting(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      settingOnlineViewPublicFormat: {
        isShowSignatureOnPublicLink: input.isShowSignatureOnPublicLink,
        isShowStampOnPublicLink: input.isShowStampOnPublicLink,
        isUsePassCodeOnPublicLink: input.isUsePassCodeOnPublicLink,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateOnlineViewPublicFormatSetting", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetOnlineViewPublicFormatSetting() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetOnlineViewPublicFormatSetting", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRequestTaxInvoice() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/RequestTaxInvoice/GetLink", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoActiveLinkRequestTaxInvoice(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect
      .post("/api/RequestTaxInvoice/ActiveLink", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertRequestTaxInvoiceSetting(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect
      .post("/api/RequestTaxInvoice/InsertLink", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateRequestTaxInvoiceSetting(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect
      .post("/api/RequestTaxInvoice/UpdateLink", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetOnboardingUserLog() {
    let _input = {
      userId: userInfo.UserId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetOnboardingUserLog", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetOnboardingMerchantLog() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetOnboardingMerchantLog", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateOnboardingLog(onboardingLog) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      onboardingLog: onboardingLog,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateOnboardingLog", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoConnectPage365(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input.merchantToken,
    };
    return API.peakAppConnect.post("/api/Page365/CreateToken", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetSettingDebitNoteCreditNoteNonRefAccountId() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetSettingCreditNoteDebitNoteNonRefAccountId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTokenDataPage365() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect.post("/api/Page365/GetTokenData", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTokenConfigDataPage365() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/Page365/GetTokenConfigData", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteTokenPage365() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect.post("/api/Page365/DeleteToken", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateTokenConfigPage365(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect.post("/api/Page365/UpdateConfigData", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoFetchOrderByPeroidPage365(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect
      .post("/api/Page365/FetchOrderByPeriod", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoConnectBentoWeb(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect.post("/api/BentoWeb/CreateToken", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTokenDataBentoWeb() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect.post("/api/BentoWeb/GetTokenData", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTokenConfigDataBentoWeb() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/BentoWeb/GetTokenConfigData", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteTokenBentoWeb() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect.post("/api/BentoWeb/DeleteToken", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateConfigBentoWeb(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect
      .post("/api/BentoWeb/UpdateConfigData", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoFetchOrderByCodeBentoWeb(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        orderCode: input.orderCode,
      },
    };
    return API.peakAppConnect
      .post("/api/BentoWeb/FetchOrderByCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoFetchOrderByPeroidBentoWeb(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        periodFrom: input.periodFrom,
        periodTo: input.periodTo,
      },
    };
    return API.peakAppConnect
      .post("/api/BentoWeb/FetchOrderByPeriod", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoConnectLineMyShop(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect.post("/api/LineMyShop/CreateToken", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTokenDataLineMyShop() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect.post("/api/LineMyShop/GetTokenData", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoDeleteTokenLineMyShop() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect.post("/api/LineMyShop/DeleteToken", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTokenConfigDataLineMyShop() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/LineMyShop/GetTokenConfigData", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateConfigLineMyShop(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect
      .post("/api/LineMyShop/UpdateConfigData", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoFetchOrderByPeriodLineMyShop(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect
      .post("/api/LineMyShop/FetchOrderByPeriod", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateAuthenticationShopee(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        type: input,
      },
    };
    return API.peakAppConnect
      .post("/api/Shopee/CreateAuthentication", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateTokenShopee(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        shopId: input.shopId,
        code: input.code,
      },
    };
    return API.peakAppConnect.post("/api/Shopee/CreateToken", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTokenDataShopee() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect.post("/api/Shopee/GetTokenData", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetConnectionConfigShopee() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/Shopee/GetConnectionConfig", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteTokenShopee(shopId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        shopId: shopId,
      },
    };
    return API.peakAppConnect.post("/api/Shopee/DeleteToken", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTokenConfigDataShopee(shopId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        shopId: shopId,
      },
    };
    return API.peakAppConnect
      .post("/api/Shopee/GetTokenConfigData", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateConfigShopee(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect.post("/api/Shopee/UpdateConfigData", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoFetchOrderByCodeShopee(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect.post("/api/Shopee/FetchOrderByCode", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoFetchOrderByPeroidShopee(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect
      .post("/api/Shopee/FetchOrderByPeriod", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateAuthenticationLazada() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/Lazada/CreateAuthentication", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateTokenLazada(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        code: input.code,
      },
    };
    return API.peakAppConnect.post("/api/Lazada/CreateToken", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTokenDataLazada() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect.post("/api/Lazada/GetTokenData", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoCreateAuthenticationTiktok() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/Tiktok/CreateAuthentication", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateTokenTiktok(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        code: input.code,
      },
    };
    return API.peakAppConnect.post("/api/Tiktok/CreateToken", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTokenDataTiktok() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect.post("/api/Tiktok/GetTokenData", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetOpenApiPartnerUserTokenTable(data) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: data,
    };
    return API.peakAppConnect
      .post("/api/OpenApi/GetOpenApiPartnerUserTokenTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetOpenApiPartnerUserTokenMonitor(data) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: data,
    };
    return API.peakAppConnect
      .post("/api/OpenApi/GetOpenApiPartnerUserTokenMonitor", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetOpenApiPartnerMerchantReport(data) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: data,
    };
    return API.peakAppConnect
      .post("/api/OpenApi/GetOpenApiPartnerMerchantReport", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetOpenApiPartnerUsageSummary(data) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: data,
    };
    return API.peakAppConnect
      .post("/api/OpenApi/GetOpenApiPartnerUsageSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetConnectionConfigLazada() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/Lazada/GetConnectionConfig", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteTokenLazada(sellerId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        sellerId: sellerId,
      },
    };
    return API.peakAppConnect.post("/api/Lazada/DeleteToken", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTokenConfigDataLazada(sellerId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        sellerId: sellerId,
      },
    };
    return API.peakAppConnect
      .post("/api/Lazada/GetTokenConfigData", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateConfigLazada(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect.post("/api/Lazada/UpdateConfigData", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoFetchOrderByCodeLazada(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        orderCode: input.orderCode,
        sellerId: input.sellerId ? input.sellerId : "",
      },
    };
    return API.peakAppConnect.post("/api/Lazada/FetchOrderByCode", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoFetchOrderByPeroidLazada(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        sellerId: input.sellerId,
        periodFrom: input.periodFrom,
        periodTo: input.periodTo,
      },
    };
    return API.peakAppConnect
      .post("/api/Lazada/FetchOrderByPeriod", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetConnectionConfigTiktok() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/Tiktok/GetConnectionConfig", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteTokenTiktok(sellerId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        sellerId: sellerId,
      },
    };
    return API.peakAppConnect.post("/api/Tiktok/DeleteToken", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTokenConfigDataTiktok(sellerId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        sellerId: sellerId,
      },
    };
    return API.peakAppConnect
      .post("/api/Tiktok/GetTokenConfigData", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateConfigTiktok(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect.post("/api/Tiktok/UpdateConfigData", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoFetchOrderByCodeTiktok(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        orderCode: input.orderCode,
        sellerId: input.sellerId ? input.sellerId : "",
      },
    };
    return API.peakAppConnect.post("/api/Tiktok/FetchOrderByCode", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoFetchOrderByPeroidTiktok(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        sellerId: input.sellerId,
        periodFrom: input.periodFrom,
        periodTo: input.periodTo,
      },
    };
    return API.peakAppConnect
      .post("/api/Tiktok/FetchOrderByPeriod", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetClientUserDataAPIOwnUse() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/OpenApi/GetOpenApiClientUserData", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoValidateClientUserAPIOwnUse(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        clientCode: input.clientCode,
      },
    };
    return API.peakAppConnect
      .post("/api/OpenApi/ValidateOpenApiClientUser", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertUserTokenAPIOwnUse(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        clientCode: input.clientCode,
      },
    };
    return API.peakAppConnect
      .post("/api/OpenApi/InsertOpenApiUserToken", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRemoveUserTokenAPIOwnUse(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        clientUserId: input.clientUserId,
        userTokenId: input.userTokenId,
      },
    };
    return API.peakAppConnect
      .post("/api/OpenApi/RemoveOpenApiUserToken", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingDebitNoteCreditNoteNonRefAccountId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      setting: input,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/SettingCreditNoteDebitNoteNonRefAccountId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAccountingFirmMerchantByMerchantId() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetAccountingFirmMerchantByMerchantId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAccountingFirmByAfpRefCode(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      afpRefCode: input.afpRefCode,
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetAccountingFirmByAfpRefCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRegisterAccountingFirmToMerchant(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      accountingFirmId: input.accountingFirmId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/RegisterAccountingFirmToMerchant", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUnRegisterAccountingFirmToMerchant(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      accountingFirmMerchantId: input.accountingFirmMerchantId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UnRegisterAccountingFirmToMerchant", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetOnboardingNewPeak() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetOnboardingNewPeak", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateOnboardingNewPeak(onboardingNewPeakType) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      onboardingNewPeakType: onboardingNewPeakType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateOnboardingNewPeak", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRedeemOnboardingNewPeak(isRedeem) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      isRedeem: isRedeem,
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetRedeemOnboardingNewPeak", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetOnBoardingMerchantSample() {
    const headers = userInfo.SetHeaderService().headers;
    return API.peakRealTimeAPI.get("/api/Merchant/GetOnBoardingMerchantSample", { headers }).then((res) => {
      return res;
    });
  },
  DoCreateContactMerchantSample() {
    let _input = {};
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/CreateContactMerchantSample", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateBankAccountMerchantSample() {
    let _input = {};
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/CreateBankAccountMerchantSample", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateProductMerchantSample() {
    let _input = {};
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/CreateProductMerchantSample", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateAllocationMerchantSample() {
    let _input = {};
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/CreateAllocationMerchantSample", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateQrCodeMerchantSample() {
    let _input = {};
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/CreateQrCodeMerchantSample", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateInvoiceMerchantSample() {
    let _input = {};
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/CreateInvoiceMerchantSample", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateInvoiceWithReceiptMerchantSample() {
    let _input = {};
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/CreateInvoiceWithReceiptMerchantSample", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateReceiptMerchantSample() {
    let _input = {};
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/CreateReceiptMerchantSample", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateExpenseMerchantSample(createExpenseMerchantSample) {
    let _input = {
      data: {
        createExpenseMerchantSample: createExpenseMerchantSample,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/CreateExpenseMerchantSample", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateJournalMerchantSample() {
    let _input = {};
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/CreateJournalMerchantSample", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateCustomDashBoardMerchantSample() {
    let _input = {};
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/CreateCustomDashBoardMerchantSample", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateStatusMerchantSample() {
    let _input = {};
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateStatusMerchantSample", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFavoriteMerchant() {
    let _input = {};
    return API.peakAPI.post("/api/Merchant/GetFavoriteMerchant", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateFavoriteMerchant(merchantId) {
    let _input = {
      merchantId: merchantId,
    };
    return API.peakAPI.post("/api/Merchant/UpdateFavoriteMerchant", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoDeleteFavoriteMerchant(merchantId) {
    let _input = {
      merchantId: merchantId,
    };
    return API.peakAPI.post("/api/Merchant/DeleteFavoriteMerchant", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetSettingViewTransaction(input) {
    let _input = {
      data: {
        transactionType: input.transactionType,
        financeType: input.financeType,
        expenseType: input.expenseType ? input.expenseType : enums.TransactionItemType.None,
        isRecerring: input.isRecerring,
        merchantIsVat: input.merchantIsVat,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetSettingViewTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingViewTransaction(input) {
    let _input = {
      data: {
        transactionType: input.transactionType,
        financeType: input.financeType,
        expenseType: input.expenseType,
        isRecerring: input.isRecerring,
        settingViewTemplate: input.settingViewTemplate,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateSettingViewTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoDeleteMerchant(merchantName) {
    let _input = {
      data: merchantName,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/DeleteMerchant", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCheckIsCreatedMerchantNotSample(isUseMainDatabase = false) {
    let _input = {
      isUseMainDatabase: isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/Merchant/CheckIsCreatedMerchantNotSample", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDemoOrganizeGuide() {
    let _input = {
      data: {},
    };

    return API.peakRealTimeAPI
      .post("/api/Merchant/GetDemoOrganizeGuide", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateDemoOrganizeGuide(demoOrganizeGuideType) {
    let _input = {
      data: {
        demoOrganizeGuideType: demoOrganizeGuideType,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateDemoOrganizeGuide", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertSCBQRCodePayment(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        billerId: input.billerId,
        prefix: input.prefix,
        bankAccountId: input.bankAccountId,
        language: i18n.locale,
      },
    };
    return API.peakAppConnect
      .post("/api/SCB/InsertSCBQRCodePayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertBayQRCodePayment(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        billerId: input.billerId,
        bankAccountId: input.bankAccountId,
        language: i18n.locale,
      },
    };
    return API.peakAppConnect
      .post("/api/Bay/InsertBayQRCodePayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertBblQRCodePayment(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        billerId: input.billerId,
        bankAccountId: input.bankAccountId,
        language: i18n.locale,
      },
    };
    return API.peakAppConnect
      .post("/api/Bbl/InsertBblQRCodePayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertBaySettingStatement(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect
      .post("/api/Bay/InsertBaySettingStatement", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateBankAccountBayStatement(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect
      .post("/api/Bay/UpdateBankAccountBayStatement", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRemoveBankAccountBayStatement(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect
      .post("/api/Bay/RemoveBankAccountBayStatement", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBayStatement(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect.post("/api/Bay/GetBayStatement", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetBayGenerateStatement(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: input,
    };
    return API.peakAppConnect
      .post("/api/Bay/GetBayGenerateStatement", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidBaySettingStatement() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/Bay/VoidBaySettingStatement", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBaySettingStatement() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAppConnect
      .post("/api/Bay/GetBaySettingStatement", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertBeamPayment(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        beamMerchantId: input.beamMerchantId,
        secretKey: input.secretKey,
        apiKey: input.apiKey,
        bankAccountId: input.bankAccountId,
        language: i18n.locale,
      },
    };
    return API.peakAppConnect.post("/api/Beam/InsertBeamPayment", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoInsertPaySolutionPayment(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        bankAccountId: input.bankAccountId,
        paySolutionMerchantId: input.paySolutionMerchantId,
        secretKey: input.secretKey,
        apiKey: input.apiKey,
        customerEmail: input.customerEmail,
      },
    };
    return API.peakAppConnect
      .post("/api/PaySolution/InsertPaySolutionPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertChillPayPayment(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        bankAccountId: input.bankAccountId,
        chillPayMerchantCode: input.chillPayMerchantCode,
        apiKey: input.apiKey,
        md5Key: input.md5Key,
        merchantName: input.merchantName,
        paymentChannel: input.mainPaymentChannel,
      },
    };
    return API.peakAppConnect
      .post("/api/ChillPay/InsertChillPayPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoVoidQrPaymentCode(qrPaymentTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      qrPaymentTypeId: qrPaymentTypeId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/VoidQrPaymentCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingProduct() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetSettingProduct", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingProduct(settingProduct) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      skuTemplateModelList: settingProduct.skuTemplateModelList,
      settingProductModel: settingProduct.settingProductModel,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateSettingProduct", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingPaymentConfigModel(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      settingPaymentConfigModel: {
        bankAccountId: input.bankAccountId,
        accountId: input.accountId,
        isAutoCreateReceipt: input.isAutoCreateReceipt,
        isAutoCreateTaxInvoiceReceipt: input.isAutoCreateTaxInvoiceReceipt,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateSettingPaymentConfigModel", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQRPaymentSetting() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetQRPaymentSetting", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantSettingTaxInvoice() {
    let _input = {
      data: {},
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetMerchantSettingTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateMerchantSettingTaxInvoice(settingTaxInvoice) {
    let _input = {
      data: {
        settingTaxInvoice: settingTaxInvoice,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateMerchantSettingTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingQuotationPartial() {
    let _input = {};
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetSettingQuotationPartial", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingQuotationPartial(settingQuotationPartial) {
    let _input = {
      settingQuotationPartial: settingQuotationPartial,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateSettingQuotationPartial", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingPurchaseOrderPartial() {
    let _input = {};
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetSettingPurchaseOrderPartial", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingPurchaseOrderPartial(settingPurchaseOrderPartial) {
    let _input = {
      settingPurchaseOrderPartial: settingPurchaseOrderPartial,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateSettingPurchaseOrderPartial", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantSettingDocumentReportURL() {
    let _input = {
      data: {},
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetMerchantSettingDocumentReportURL", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateMerchantSettingDocumentReportURL(settingDocumentReportURL) {
    let _input = {
      data: {
        settingDocumentReportURL: settingDocumentReportURL,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateMerchantSettingDocumentReportURL", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantSettingCreateUserJournal() {
    let _input = {
      data: {},
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetSettingCreateUserJournal", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateMerchantSettingCreateUserJournal(settingCreateUserJournal) {
    let _input = {
      data: {
        settingCreateJournal: settingCreateUserJournal,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Merchant/UpdateSettingCreateUserJournal", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingPaymentDefault(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      settingPaymentDefaultModel: input,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/Merchant/UpdateSettingPaymentDefault", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingPaymentDefault() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetSettingPaymentDefault", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertUserRole(input) {
    return API.peakRealTimeAPI.post("/api/user/InsertRole", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoEditUserRole(input) {
    return API.peakRealTimeAPI.post("/api/user/EditRole", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetRoleDetail(input) {
    return API.peakRealTimeAPI.post("/api/user/GetRoleDetail", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoInviteUserRole(input) {
    return API.peakRealTimeAPI.post("/api/v2/user/AddNewUser", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoDeleteUserRole(input) {
    return API.peakRealTimeAPI.post("/api/user/deleterole", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoValidateTransferSuperAdmin(input) {
    return API.peakRealTimeAPI
      .post("/api/Merchant/ValidateTransferSuperAdmin", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoTransferSuperAdmin(input) {
    return API.peakRealTimeAPI
      .post("/api/Merchant/TransferSuperAdmin", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoValidatePassword(input) {
    return API.peakRealTimeAPI.post("/api/User/ValidatePassword", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
};
